import { makeStyles } from "@material-ui/core/styles";
export default makeStyles(theme => ({
    root: {},
    dialog: {
        width: 350,
    },
    childAges: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: theme.spacing(0.5),
    },
    categories: {
        marginBottom: theme.spacing(2),
        '& > :not(:last-child)': {
            marginBottom: theme.spacing(1),
        }
    },
    countBtn: {
        border: `1px solid ${theme.palette.grey[200]}`
    }
}));
